import { gql } from '@apollo/client';
import { LEASE_INFO_FRAGMENT } from 'graphql/leases';
import { PRICE_QUOTE_INFO_FRAGMENT } from 'graphql/propertyPriceQuote/fragments';
import { SALE_BASIC_DATA_FRAGMENT } from 'graphql/sales/fragments';
import { TIM_FRAGMENT } from 'graphql/tims/fragments';
import {
  USER_BASIC_FIELDS,
  ID_NAME_FIELDS,
  COUNTRY_FIELDS,
  ID_NAME_WEBSITE_LOGO_FIELDS,
  PROPERTY_MAIN_FIELDS,
} from 'graphql/common/fragments';

export const GET_ACTIVITIES_QUERY = gql`
  query getActivities($search: ActivitySearchInput) {
    activities(search: $search) {
      totalPages
      currentPage
      results {
        id
        activityDate
        user {
          ${USER_BASIC_FIELDS}
        }
        userEdited {
          ${USER_BASIC_FIELDS}
        }
        property {
          ${PROPERTY_MAIN_FIELDS}
          propertyCountry {
            ${COUNTRY_FIELDS}
          }
          status {
            ${ID_NAME_FIELDS}
          }
          propertyClass {
            ${ID_NAME_FIELDS}
          }
          market {
            ${ID_NAME_FIELDS}
          }
          submarket {
            ${ID_NAME_FIELDS}
          }
          micromarket {
            ${ID_NAME_FIELDS}
          }
          propertyType {
            ${ID_NAME_FIELDS}
          }
          coverMediaUrl
          coverMediaType
        }
        scoop {
          id
          documentCount
          text
          userId
          url
          scoopMediaUrl
          scoopMediaId
          user {
            ${USER_BASIC_FIELDS}
          }
          lastEditedUser {
            ${USER_BASIC_FIELDS}
          }
          lastEditedUserId
          createdAt
          updatedAt
          propertyId
          totalScoopComments
          propertyTypes {
            ${ID_NAME_FIELDS}
          }
          scoopCategories {
            ${ID_NAME_FIELDS}
          }
          companies {
            ${ID_NAME_FIELDS}
            mergedCompanyId
            mergedCompany {
              ${ID_NAME_FIELDS}
            }
          }
          properties {
            ${PROPERTY_MAIN_FIELDS}
            longLeaseHolders {
              ${ID_NAME_WEBSITE_LOGO_FIELDS}
            }
            owners {
              ${ID_NAME_WEBSITE_LOGO_FIELDS}
            }
            market {
              ${ID_NAME_FIELDS}
            }
            submarket {
              ${ID_NAME_FIELDS}
            }
            micromarket {
              ${ID_NAME_FIELDS}
            }
            propertyType {
              ${ID_NAME_FIELDS}
            }
            propertyClass {
              ${ID_NAME_FIELDS}
            }
          }
          markets {
            ${ID_NAME_FIELDS}
            latitude
            longitude
            mediaUrl
            country {
              ${ID_NAME_FIELDS}
            }
          }
          scoopComments {
            id
            comment
            createdAt
            userId
            user {
              ${USER_BASIC_FIELDS}
            }
          }
        }
        lease {
          ...leaseInfo
        }
        sale {
          ...saleBasicData
        }
        propertyPriceQuote {
          ...priceQuoteInfo
        }
        tenantInMarketId
        TIM {
          ...TIMFragment
        }
      }
    }
  }
  ${PRICE_QUOTE_INFO_FRAGMENT}
  ${LEASE_INFO_FRAGMENT}
  ${SALE_BASIC_DATA_FRAGMENT}
  ${TIM_FRAGMENT}
`;
